import Lenis from 'lenis';

// Fuente de progreso 0..1 del recorrido completo.
// Desktop: Lenis (la inercia es la que hace que el scrub se sienta caro).
// Mobile: scroll nativo — mejor rendimiento y respeta el gesto del sistema.
//
// El progreso se lee de la posición del contenedor en pantalla, así funciona
// igual si el hero está al inicio de la página o incrustado más abajo (WordPress).
const isMobile = matchMedia('(pointer: coarse)').matches || window.innerWidth < 768;

/**
 * @param {HTMLElement} el  el riel de scroll.
 * @param {number} [leadPx] píxeles iniciales del riel que NO pertenecen al
 *   recorrido 3D: los ocupa el hero de Julio mientras la tinta lo borra. El
 *   progreso se queda en 0 hasta pasarlos, así ambos comparten un solo riel
 *   (que es lo que permite que la tinta descubra el canvas vivo).
 */
export function createScroll(el, leadPx = 0) {
  const lenis = isMobile ? null : new Lenis({ lerp: 0.1, smoothWheel: true });

  function raf(timeMs) {
    if (lenis) lenis.raf(timeMs);
  }

  // LA GEOMETRÍA DEL RIEL SE CACHEA. No es microoptimización: `getProgress()` se
  // llama una vez por fotograma desde el bucle del recorrido, y justo antes el
  // hero ha escrito ~10 estilos en línea desde SU bucle. Leer un rect después de
  // escribir obliga al navegador a recalcular la maquetación de forma
  // sincrónica, ahí mismo.
  //
  // MEDIDO interceptando `getBoundingClientRect` (143 fotogramas, fase del hero):
  // esta misma llamada costaba 0.375 ms de media y hasta 1.8 ms, contra 0.026 ms
  // dentro del recorrido —donde el hero ya no escribe y no hay nada que
  // recalcular—. Catorce veces más cara por el orden en que se hacen las cosas,
  // no por lo que hace.
  //
  // Alto y posición del riel solo cambian al redimensionar (y el alto lo fija
  // main.js una vez, antes del primer pintado, para no provocar CLS). Así que se
  // leen una vez y la posición de scroll se consulta a `scrollY`, que NO fuerza
  // maquetación.
  let railTop = 0, railH = 0, vh = 0;
  function medirRiel() {
    const r = el.getBoundingClientRect();
    railTop = r.top + window.scrollY;
    railH = r.height;
    vh = window.innerHeight;
  }
  medirRiel();
  window.addEventListener('resize', medirRiel, { passive: true });

  function getProgress() {
    // Si el riel aún no tenía alto al medir (fuentes sin cargar, pestaña en
    // segundo plano), se vuelve a medir: es la única vez que hace falta.
    if (!railH) medirRiel();
    const travel = railH - vh - leadPx;
    if (travel <= 0) return 0;
    // `lenis.scroll` es `animatedScroll`: estado de JS, cero contacto con el DOM.
    // Es además EL MISMO valor que Lenis acaba de escribir en la página, así que
    // no se pierde precisión. En móvil no hay Lenis y `scrollY` sirve: comprobado
    // en lenis 1.3.25 que `setScroll` usa `scrollTo({behavior:'instant'})`, o sea
    // scroll nativo, y por tanto `scrollY` refleja la posición real.
    const y = lenis ? lenis.scroll : window.scrollY;
    return Math.min(Math.max((y - railTop - leadPx) / travel, 0), 1);
  }

  // Se expone `lenis` para que quien haga scroll PROGRAMADO (p. ej. la sección
  // "¿Qué es Zenkai?" al abrir su video) pueda pausarlo mientras dura: si no,
  // Lenis reescribe la posición cada frame y los dos se pelean.
  return { raf, getProgress, isMobile, lenis };
}
